import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__intro">
          <a href="/" className="footer__brand" aria-label="byond care">
            <img src="/images/logo.png" alt="byond care" />
          </a>
          <p>Beyond the visit. Built for Malaysian healthcare.</p>
          <div className="footer__stores">
            <a href="https://apps.apple.com/my/app/xsbenefits/id1660439949" target="_blank" rel="noreferrer">
              <img src="/images/appstore.svg" alt="Download on the App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.lll.xsbenefits.prod" target="_blank" rel="noreferrer">
              <img src="/images/googleplay.png" alt="Get it on Google Play" />
            </a>
          </div>
        </div>
        <div className="footer__col">
          <h5>Product</h5>
          <a href="#features">Features</a>
          <a href="#patient-app">Patient App</a>
          <a href="#pricing">Pricing</a>
          <a href="#demo">Book a Demo</a>
        </div>
        <div className="footer__col">
          <h5>Company</h5>
          <a href="#about">About</a>
          <a href="#resources">Resources</a>
          <a href="/">Privacy Policy</a>
          <a href="/">Terms of Service</a>
        </div>
        <div className="footer__col">
          <h5>Contact</h5>
          <a href="mailto:hello@byondcare.com.my">hello@byondcare.com.my</a>
          <a href="/">LinkedIn</a>
          <a href="/">Facebook</a>
          <a href="/">Instagram</a>
        </div>
      </div>
      <div className="footer__bottom">
        <p className="footer__copy">
          &copy; 2026 Byondcare Sdn. Bhd. All rights reserved. | Made in Malaysia
        </p>
        <div className="footer__badges">
          <span>PDPA Compliant</span>
          <span>Malaysian Data Residency</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
